"use client"

import HomeDetailsWrapperAccordion from "@/features/homeowners/components/home-details-wrapper-accordion"
import { useWorkscopeLabelStyle, WORKSCOPE_LABEL_COLORS } from "../home-details-wrapper-accordion"
import { workScopeStatusOptions } from "../../constants/options"

const goodwillGreenStyle = { color: WORKSCOPE_LABEL_COLORS.goodwill } as const
import { HomeWithHomeOwnerFormType } from "../../schema/home-with-home-owner.schema"
import { useFormContext, useWatch } from "react-hook-form"
import FormYesNoInput from "../../../../shared/components/form-inputs/form-yes-no-input"
import FormSelectInput from "../../../../shared/components/form-inputs/form-select-input"
import WorkScopeStatusSelect from "../work-scope-status-select"
import FormMultiSelectInput from "../../../../shared/components/form-inputs/form-multi-select-input"
import FormTextInput from "@/shared/components/form-inputs/form-text-input"
import FormTextareaInput from "../../../../shared/components/form-inputs/form-textarea-input"
import DateStampedTextarea from "../../../../shared/components/form-inputs/form-date-stamped-textarea-input"
import { useClaimedByOptions } from "../../hooks/use-claimed-by-options"
import { useWorkscopeClaimedBySync } from "../../hooks/use-workscope-claimed-by-sync"
import { GoodwillToggleLabel } from "../goodwill-toggle-label"

const BASE_FIELD_NAME = "home.rebuildPrepInfo"

function HomeRebuildPrepForm() {
    const goodwillLabelStyle = useWorkscopeLabelStyle(true) ?? goodwillGreenStyle
    const { control, setValue, getValues } = useFormContext<HomeWithHomeOwnerFormType>()
    const { options: claimedByOptions, loading: claimedByLoading } = useClaimedByOptions()
    const goodwillRebuildPrepOn = useWatch({ control, name: `${BASE_FIELD_NAME}.goodwillRebuildPrepOn` })
    
    // Watch status field and claimed by field
    const rebuildPrep = useWatch({ control, name: `${BASE_FIELD_NAME}.rebuildPrep` })
    const claimedBy = useWatch({ control, name: `${BASE_FIELD_NAME}.claimedBy` })
    const goodwillRebuildPrep = useWatch({ control, name: `${BASE_FIELD_NAME}.goodwillRebuildPrep` })
    const goodwillRebuildPrepClaimedBy = useWatch({
        control,
        name: `${BASE_FIELD_NAME}.goodwillRebuildPrepClaimedBy`,
    })

    useWorkscopeClaimedBySync<HomeWithHomeOwnerFormType>({
        status: rebuildPrep,
        claimedBy,
        claimedByFieldPath: `${BASE_FIELD_NAME}.claimedBy`,
        setValue,
        getValues,
    })
    useWorkscopeClaimedBySync<HomeWithHomeOwnerFormType>({
        status: goodwillRebuildPrep,
        claimedBy: goodwillRebuildPrepClaimedBy,
        claimedByFieldPath: `${BASE_FIELD_NAME}.goodwillRebuildPrepClaimedBy`,
        setValue,
        getValues,
        enabled: !!goodwillRebuildPrepOn,
    })

    return (
        <HomeDetailsWrapperAccordion 
            heading="Rebuild Prep"
            wrapperClassName="xl:grid-cols-2"
        >
            <WorkScopeStatusSelect workScopeSlug="rebuild-prep"
                inputGroupProps={{
                    label: <GoodwillToggleLabel title="Rebuild Prep" toggleName={`${BASE_FIELD_NAME}.goodwillRebuildPrepOn` as any} control={control} />,
                }}
                options={workScopeStatusOptions}
                name={`${BASE_FIELD_NAME}.rebuildPrep`}
                control={control}
            />

            <FormMultiSelectInput
                inputGroupProps={{
                    label: "Claimed By",
                }}
                options={claimedByOptions}
                name={`${BASE_FIELD_NAME}.claimedBy`}
                control={control}
                placeholder={claimedByLoading ? "Loading options..." : "Select"}
                searchPlaceholder="Search options..."
            />
            {goodwillRebuildPrepOn && (
                <>
                    <FormSelectInput
                        inputGroupProps={{ label: "Rebuild Prep Goodwill", labelStyle: goodwillLabelStyle }}
                        options={workScopeStatusOptions}
                        name={`${BASE_FIELD_NAME}.goodwillRebuildPrep`}
                        control={control}
                    />
                    <FormMultiSelectInput
                        inputGroupProps={{ label: "Rebuild Prep Goodwill Claimed By" }}
                        options={claimedByOptions}
                        name={`${BASE_FIELD_NAME}.goodwillRebuildPrepClaimedBy`}
                        control={control}
                        placeholder={claimedByLoading ? "Loading options..." : "Select"}
                        searchPlaceholder="Search options..."
                    />
                </>
            )}
            <DateStampedTextarea
                includeUserName
                inputGroupProps={{
                    label: "Description",
                    wrapperClassName: "xl:col-span-2"
                }}
                rows={4}
                name={`${BASE_FIELD_NAME}.description`}
                control={control}
            />
        </HomeDetailsWrapperAccordion>
    )
}

export default HomeRebuildPrepForm
